import {
  ONE_DAY_MS,
  ONE_HOUR_MS,
  ONE_MINUTE_MS,
  ONE_SECOND_MS,
} from '@bldsoft/rekit/uvo/date'

export { ONE_DAY_MS, ONE_HOUR_MS, ONE_MINUTE_MS, ONE_SECOND_MS }

export const ONE_MINUTE_IN_SEC = 60
export const HOURS_IN_DAY = 24
export const ONE_HOUR_SEC = 60 * ONE_MINUTE_IN_SEC
export const HALF_HOUR_MS = 30 * ONE_MINUTE_MS
